// @flow
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import CheckBoxGroup from '../CheckBoxGroup';
import Input from 'Common/Input';

// Styles
import bootstrap from 'vendor/bootstrap/_bootstrap_custom.scss';

// Helpers
import classNames from 'classnames';
import { getKey } from 'Common/formValues';

import { withinDistanceValues } from 'Common/filterValues';

import {
  getPriceFromValues,
  getPriceToValues
} from 'Common/calculatePriceIncrements';

/**
 * <BasicFiltersResults /> component.
 * @return {class} returns BasicFiltersMultiSelect instance
 */
class BasicFiltersResults extends PureComponent<*, *> {
  /**
   * @param {object} props - props passed
   */
  constructor(props: Object) {
    super(props);
    this.state = {
      selected: ''
    };
    this.timeouts = [];
  }

  /**
   * componentDidMount
   * @return {void}
   */
  componentDidMount() {
    document.addEventListener('click', this.closeSwoosh);
  }

  /**
   * componentWillUnmount
   * @return {void}
   */
  componentWillUnmount() {
    document.removeEventListener('click', this.closeSwoosh);
    this.timeouts.forEach(clearTimeout);
  }

  /**
   * Implements propTypes().
   *
   * @return {Object} - propType object.
   * @prop {object} styles - styles.
   * @prop {array} makes - makes.
   * @prop {object} fields - fields.
   * @prop {array} models - models.
   * @prop {number} priceFrom - priceFrom.
   * @prop {number} priceTo - priceTo.
   * @prop {function} checkPostcode - checkPostcode.
   * @prop {boolean} isPostcodeValid - isPostcodeValid.
   */
  static propTypes = {
    styles: PropTypes.object.isRequired,
    makes: PropTypes.array.isRequired,
    models: PropTypes.array,
    trims: PropTypes.array,
    priceFrom: PropTypes.number,
    priceTo: PropTypes.number,
    fields: PropTypes.object,
    resetField: PropTypes.func,
    checkPostcode: PropTypes.func,
    isPostcodeValid: PropTypes.bool
  };

  /**
   * setAsSelected
   *
   * @param {string} name - name.
   * @return {void}
   */
  setAsSelected = (name: string) => {
    this.setState({
      selected: name
    });
  };

  /**
   * closeSwoosh
   *
   * @param {object} event - event.
   * @return {void}
   */
  closeSwoosh = event => {
    const selectedCheckBoxGroup = document.querySelectorAll(
      '[data-selectedcheckboxgroup=true]'
    )[0];

    if (
      selectedCheckBoxGroup &&
      !selectedCheckBoxGroup.contains(event.target)
    ) {
      this.timeouts.push(setTimeout(() => this.setAsSelected(''), 300));
    }
  };

  /**
   * Renders <BasicFilters /> component.
   *
   * @return {JSX} - renders a logo.
   */
  render() {
    const {
      styles,
      makes,
      models,
      trims,
      fields,
      priceFrom,
      priceTo,
      resetField,
      checkPostcode,
      isPostcodeValid
    } = this.props;
    return (
      <div>
        <div className={classNames(styles.formRowItem)}>
          <CheckBoxGroup
            styles={styles}
            name={'make'}
            label={'Select make'}
            selectedValue={fields.make}
            options={makes}
            isSelected={this.state.selected === 'make'}
            onSelect={() => this.setAsSelected('make')}
            setAsSelected={this.setAsSelected}
            isSwoosh={true}
            resetField={resetField}
          />

          {fields.make && (
            <CheckBoxGroup
              styles={styles}
              name={'model'}
              label={'Select model'}
              selectedValue={fields.model}
              options={models}
              isSelected={this.state.selected === 'model'}
              onSelect={() => this.setAsSelected('model')}
              setAsSelected={this.setAsSelected}
              isSwoosh={true}
              resetField={resetField}
            />
          )}

          {fields.model && (
            <CheckBoxGroup
              styles={styles}
              name={'trim'}
              label={'Select model variant'}
              selectedValue={fields.trim}
              options={trims}
              isSelected={this.state.selected === 'trim'}
              onSelect={() => this.setAsSelected('trim')}
              setAsSelected={this.setAsSelected}
              isSwoosh={true}
              resetField={resetField}
            />
          )}

          <CheckBoxGroup
            styles={styles}
            name={'cashPriceFrom'}
            label={'Price from'}
            selectedValue={fields.cashPriceFrom}
            options={getPriceFromValues(
              priceFrom,
              priceTo,
              getKey(fields.cashPriceTo)
            )}
            disableCounts={true}
            isSelected={this.state.selected === 'cashPriceFrom'}
            onSelect={() => this.setAsSelected('cashPriceFrom')}
            setAsSelected={this.setAsSelected}
            resetField={resetField}
            isSwoosh={true}
          />

          <CheckBoxGroup
            styles={styles}
            name={'cashPriceTo'}
            label={'Price to'}
            selectedValue={fields.cashPriceTo}
            options={getPriceToValues(
              priceFrom,
              priceTo,
              getKey(fields.cashPriceFrom)
            )}
            disableCounts={true}
            isSelected={this.state.selected === 'cashPriceTo'}
            onSelect={() => this.setAsSelected('cashPriceTo')}
            setAsSelected={this.setAsSelected}
            resetField={resetField}
            isSwoosh={true}
          />

          <Input
            styles={styles}
            bootstrap={bootstrap}
            name={'postCode'}
            label={'Postcode'}
            resetField={this.props.resetField}
            onChangeHandler={checkPostcode}
            selectedValue={fields.postCode}
            isLabelHidden={true}
            placeholderText={'Enter here'}
            isValid={!fields.postCode ? true : isPostcodeValid}
            errorMessage={'Postcode invalid'}
          />

          {fields.isPostCodeValid && (
            <CheckBoxGroup
              styles={styles}
              name={'withinDistance'}
              label={'Distance'}
              selectedValue={fields.withinDistance}
              options={withinDistanceValues}
              disableCounts={true}
              isSelected={this.state.selected === 'withinDistance'}
              onSelect={() => this.setAsSelected('withinDistance')}
              setAsSelected={this.setAsSelected}
              disableFiltering={true}
              resetField={resetField}
            />
          )}
        </div>
      </div>
    );
  }
}

export default BasicFiltersResults;



// WEBPACK FOOTER //
// ./src/Results/BasicFiltersResults/index.js